module.exports = __webpack_public_path__ + "img/zxl_logo.44a6b1d7.png";